import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { register as registerSwiperElements } from 'swiper/element/bundle';
import Quill from 'quill';
import { EmojiBlot, ShortNameEmoji, ToolbarEmoji, TextAreaEmoji } from '@windmillcode/quill-emoji';

Quill.register(EmojiBlot);
Quill.register('modules/emoji-shortname', ShortNameEmoji, true);
Quill.register('modules/emoji-toolbar', ToolbarEmoji, true);
Quill.register('modules/emoji-textarea', TextAreaEmoji, true);

if (environment.production) {
  enableProdMode();
}

// Register Swiper custom elements. We do this
// before bootstrapping the Angular application
// so that they're available before any part of
// our application tries rendering them.
registerSwiperElements();

platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], });
